module.exports = __webpack_public_path__ + "img/VetsGo-Login-Mobile.c5762406.svg";